import React from 'react';
import { Profile } from '@/types/auth';
import { Button } from '@/components/ui/button';
import { Mail, MessageSquare } from 'lucide-react';

interface ContactWidgetProps {
  profile: Profile;
}

export const ContactWidget: React.FC<ContactWidgetProps> = ({ profile }) => {
  return (
    <div className="h-full">
      <h3 className="text-sm font-medium text-muted-foreground mb-4">Contact</h3>
      
      <div className="space-y-3 h-[calc(100%-2rem)]">
        {profile.email && (
          <Button
            variant="outline"
            className="w-full justify-start"
            asChild
          >
            <a href={`mailto:${profile.email}`}>
              <Mail className="h-4 w-4 mr-2" />
              Send Email
            </a>
          </Button>
        )}
        
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() => {
            // This could open a DM modal or navigate to messages
            console.log('Send message to', profile.username);
          }}
        >
          <MessageSquare className="h-4 w-4 mr-2" />
          Send Message
        </Button>
        
        <div className="text-center text-muted-foreground pt-4">
          <p className="text-xs">
            @{profile.username}
          </p>
        </div>
      </div>
    </div>
  );
};